export default "__VITE_ASSET__7M4aDk_r__"